import { createStateSelectorHook } from 'src/lib/sweetState';
import { ToneOfVoiceStore } from 'src/store';

const useToneOfVoiceState = createStateSelectorHook(ToneOfVoiceStore, ['extractingToneOfVoice']);

export const useIsExtractingToneOfVoice = () => {
  const { extractingToneOfVoice } = useToneOfVoiceState();
  return extractingToneOfVoice;
};
